export default __webpack_public_path__ + "static/media/SphereCorePrime.83d97b8c.webp";